var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoiceCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4D7BFD",
    fillOpacity: 0.05,
    d: "M42.5 85C65.972 85 85 65.972 85 42.5S65.972 0 42.5 0 0 19.028 0 42.5 19.028 85 42.5 85z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M43 72c14.36 0 26-1.343 26-3s-11.64-3-26-3-26 1.343-26 3 11.64 3 26 3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M29.044 42.744c3.2 6.446 8.356 11.708 14.645 15.01l4.889-5.01c.6-.616 1.489-.82 2.266-.547a24.785 24.785 0 0 0 7.934 1.298C60 53.495 61 54.52 61 55.773v7.95C61 64.974 60 66 58.778 66 37.91 66 21 48.666 21 27.278 21 26.025 22 25 23.222 25H31c1.222 0 2.222 1.025 2.222 2.278 0 2.847.445 5.58 1.267 8.131a2.326 2.326 0 0 1-.556 2.324z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-285 48.5 26)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0000FF",
    d: "M36.895 27.678l3.204 3.047c4.421-4.205 11.598-4.205 16.02 0l3.203-3.047c-6.183-5.882-16.228-5.882-22.427 0zm7.11 6.922l4.49 4.525 4.488-4.525c-2.469-2.504-6.494-2.504-8.977 0zM30.45 21.622l3.16 2.927c7.852-7.273 20.586-7.273 28.438 0l3.16-2.927c-9.59-8.883-25.152-8.883-34.758 0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceCall);
export default __webpack_public_path__ + "static/media/VoiceCall.b516460a574be4b46ded459d0f3885c5.svg";
export { ForwardRef as ReactComponent };